

import React from 'react';
import {
    bindActionCreators
} from 'redux';
import {
    connect
} from 'react-redux';

// import _ from 'underscore';

import DemoCarousel from '../theme/DemoCarousel'


class LottoLive extends React.Component {
    constructor() {
        super();
        this.state = {
            width: 0,
            mesajVizual: false,
            ifrHeight: undefined,
            ifrWidth: 0
        };
    }
    componentDidMount() {
        if (this.props.conSizeChange) {
            var aspectRatio = 676 / 353;
            var width = this.props.conSizeChange.colMidW
            var extragerLiveHeight = Math.round(width / aspectRatio)
            this.setState({
                ifrHeight: extragerLiveHeight
            })
        }
        window.addEventListener('resize', this.extragerLiveResponsive.bind(this), false);
        window.addEventListener('message', this.mesajVizual.bind(this), false);
    }
    componentWillUnmount() {
        window.removeEventListener('resize', this.extragerLiveResponsive.bind(this), false);
        window.removeEventListener('message', this.mesajVizual.bind(this), false);
    }
    componentDidUpdate(prevProps, prevState) {
        if (this.ifr && prevState.mesajVizual === false && this.state.mesajVizual === true) {
            var data = JSON.stringify(this.live3())
            this.ifr.contentWindow.postMessage([data, this.props.sessionParam], "*");
            this.setState({
                mesajVizual: false
            })
        }
        if (this.ifr && prevProps.activeLot && this.props.activeLot && prevProps.activeLot !== this.props.activeLot) {
            data = JSON.stringify(this.live3())
            this.ifr.contentWindow.postMessage([data, this.props.sessionParam], "*");
        }
    }

    mesajVizual(val) {
        if (val.data.type === "request" && this.state.mesajVizual === false) {
            this.setState({
                mesajVizual: true
            })
        }
    }
    live3() {
        var data = {
            prefix: this.props.activeLot.prefix,
            language: this.props.defaultVal.language
        }
        return data
    }
    extragerLiveResponsive() {
        if (this.ifr) {
            var aspectRatio = 676 / 353;
            var width = this.ifr.offsetWidth;
            var extragerLiveHeight = Math.round(width / aspectRatio)
            this.setState({
                ifrHeight: extragerLiveHeight,
                ifrWidth: width
            })
        }
    }

    render() {
        var rutaVizual
        if (this.state.ifrWidth <= 450 && this.state.ifrWidth > 0) {
            rutaVizual = this.props.appProps.rutaVizual + '?mobile=true&' + this.props.sessionParam
        } else {
            rutaVizual = this.props.appProps.rutaVizual + '?mobile=false&' + this.props.sessionParam
        }
        if (this.state.ifrHeight && this.props.activeLot && this.props.activeLot.name_lot === this.props.liveLot) {
            return (
                <iframe ref={(f) => this.ifr = f} className="lotto-live" style={{
                    height: this.state.ifrHeight

                }}
                    title="lottoLive"
                    src={rutaVizual}
                    frameBorder="0" >
                </iframe>
            )
        } else if (this.props.appProps.slider === true) {
            return (
                <div className="con-header-imgBut">
                    <div className="slider">
                        <DemoCarousel />
                    </div>
                    <div className="slider-spacer"></div>
                </div>
            )
        } else {
            return <div></div>
        }
    }
}

function mapStateToProps(state) {
    return {
        appProps: state.appProps,
        defaultVal: state.defaultVal,
        activeLot: state.activeLot,
        liveRounds: state.liveRounds,
        loterii: state.loterii,
        liveLot: state.liveLot,
        multiLang: state.multiLang,
        conSizeChange: state.conSizeChange,
        sessionParam: state.sessionParam
    }
}

function matchDispatchToProps(dispatch) {
    return bindActionCreators({
        // acLiveLot: acLiveLot
    }, dispatch)
}
export default connect(mapStateToProps, matchDispatchToProps)(LottoLive);